const types = [
  {
    text: 'All',
    value: ''
  },
  {
    text: 'Direct',
    value: 'direct'
  },
  {
    text: 'Agency',
    value: 'agency'
  }
]
const platformLists = [
  {
    text: 'All',
    value: ''
  },
  {
    text: 'Instagram',
    value: 'instagram'
  },
  {
    text: 'TikTok',
    value: 'tiktok'
  },
  {
    text: 'Youtube',
    value: 'youtube'
  },
  {
    text: 'LinkedIn',
    value: 'linkedin'
  },
  {
    text: 'X (Twitter)',
    value: 'twitter'
  },
  {
    text: 'Xiaohongshu',
    value: 'xiaohongshu'
  }
]

// const influencerTiers = [
//   {
//     label: 'Tier 1: >1m',
//     from: 1000000,
//     to: null
//   },
//   {
//     label: 'Tier 2: 500K-1m',
//     from: 500000,
//     to: 1000000
//   },
//   {
//     label: 'Tier 3: 100K - 500K',
//     from: 100000,
//     to: 500000
//   },
//   {
//     label: 'Tier 4: 50K - 100K',
//     from: 50000,
//     to: 100000
//   },
//   {
//     label: 'Tier 5: 15K - 50K',
//     from: 15000,
//     to: 50000
//   },
//   {
//     label: 'Tier 6: <15K',
//     from: null,
//     to: 15000
//   }
// ]
const influencerTiers = [
  {
    text: 'Tier 1: >1m',
    value: 0
  },
  {
    text: 'Tier 2: 500K-1m',
    value: 1
  },
  {
    text: 'Tier 3: 100K - 500K',
    value: 2
  },
  {
    text: 'Tier 4: 50K - 100K',
    value: 3
  },
  {
    text: 'Tier 5: 15K - 50K',
    value: 4
  },
  {
    text: 'Tier 6: <15K',
    value: 5
  }
]

const defaultCols = [
  'instagram',
  'tiktok',
  'linkedin',
  'twitter',
  'instagramFollowers',
  'tiktokFollowers',
  'linkedinFollowers',
  'twitterFollowers',
  'email',
  'country',
  'pastCampaigns',
  'shortDescription',
  'ccRemarks',
  'rateCard'
]

const tableHeaders = [
  {
    text: 'Name',
    value: 'name',
    align: 'start',
    sortable: false
  },
  {
    text: 'Instagram',
    value: 'instagram',
    align: 'start',
    sortable: false
  },
  {
    text: 'TikTok',
    value: 'tiktok',
    align: 'start',
    sortable: false
  },
  {
    text: 'Youtube',
    value: 'youtube',
    align: 'start',
    sortable: false
  },
  {
    text: 'LinkedIn',
    value: 'linkedin',
    align: 'start',
    sortable: false
  },
  {
    text: 'X (Twitter)',
    value: 'twitter',
    align: 'start',
    sortable: false
  },
  {
    text: 'Xiaohongshu',
    value: 'xiaohongshu',
    align: 'start',
    sortable: false
  },
  {
    text: 'Instagram Followers',
    value: 'instagramFollowers',
    align: 'start',
    sortable: false
  },
  {
    text: 'TikTok Followers',
    value: 'tiktokFollowers',
    align: 'start',
    sortable: false
  },
  {
    text: 'Youtube Followers',
    value: 'youtubeFollowers',
    align: 'start',
    sortable: false
  },
  {
    text: 'Followers (Connections)',
    value: 'linkedinFollowers',
    align: 'start',
    sortable: false
  },
  {
    text: 'X (Twitter) Followers',
    value: 'twitterFollowers',
    align: 'start',
    sortable: false
  },
  {
    text: 'XHS Followers',
    value: 'xhsFollowers',
    align: 'start',
    sortable: false
  },
  {
    text: 'Email',
    value: 'email',
    align: 'start',
    sortable: false
  },
  {
    text: 'Gender',
    value: 'gender',
    align: 'start',
    sortable: false
  },
  {
    text: 'Country',
    value: 'country',
    align: 'start',
    sortable: false
  },
  {
    text: 'Mailing Address',
    value: 'mailingAddress',
    align: 'start',
    sortable: false
  },
  {
    text: 'Postal Code',
    value: 'postalCode',
    align: 'start',
    sortable: false
  },
  {
    text: 'Date of Birth',
    value: 'dateOfBirth',
    align: 'start',
    sortable: false
  },
  {
    text: 'Age Group',
    value: 'ageGroup',
    align: 'start',
    sortable: false
  },
  {
    text: 'Past Campaigns',
    value: 'pastCampaigns',
    align: 'start',
    sortable: false
  },
  {
    text: 'Short Description',
    value: 'shortDescription',
    align: 'start',
    sortable: false
  },
  {
    text: 'CC Remarks',
    value: 'ccRemarks',
    align: 'start',
    sortable: false
  },
  {
    text: 'Stats Analysis',
    value: 'statsAnalysis',
    align: 'start',
    sortable: false
  },
  {
    text: 'Genre',
    value: 'genre',
    align: 'start',
    sortable: false
  },
  {
    text: 'Main Category',
    value: 'mainCategory',
    align: 'start',
    sortable: false
  },
  {
    text: 'Sub Category',
    value: 'subCategory',
    align: 'start',
    sortable: false
  },
  {
    text: 'Tags',
    value: 'tags',
    align: 'center',
    sortable: false
  },
  {
    text: 'Travel Form',
    value: 'travelForm',
    align: 'center',
    sortable: false
  },
  {
    text: 'Rate Card',
    value: 'rateCard',
    align: 'center',
    sortable: false
  },
  {
    text: 'IMS Profile',
    value: 'IMS',
    align: 'center',
    sortable: false
  },
  {
    text: 'Audience',
    value: 'Audience',
    align: 'center',
    sortable: false
  },
  {
    text: 'Actions',
    value: 'actions',
    align: 'start'
  }
]

const customSlots = {
  instagram: 'instagram',
  tiktok: 'tiktok',
  youtube: 'youtube',
  linkedin: 'linkedin',
  twitter: 'twitter',
  followers: 'followers'
}

export default Object.assign({}, {
  platformLists,
  influencerTiers,
  tableHeaders,
  defaultCols,
  types,
  customSlots
})



// WEBPACK FOOTER //
// ./src/components/views/Influencer/SearchCreators/config.js